"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecacheManager = void 0;
const dom_1 = require("./utils/dom");
const event_bus_1 = require("./utils/event-bus");
const spreedly_config_1 = require("./config/spreedly.config");
const field_null_exeption_1 = require("./exceptions/field-null.exeption");
const error_types_contants_1 = require("./constants/error-types.contants");
const event_types_constants_1 = require("./constants/event-types.constants");
const is_spreedly_1 = require("./utils/is-spreedly");
class RecacheManager {
    constructor(token, isProduction) {
        this.token = token;
        this.isProduction = isProduction;
        this.dom = new dom_1.Dom();
        this.eventBus = event_bus_1.EventBus.getInstance();
    }
    withCardNumber(options) {
        this.cardNumber = {
            elementId: options.elementId,
            name: 'card_number',
            placeholder: options.placeholder || ''
        };
        return this;
    }
    withCVV(options) {
        this.cvv = {
            elementId: options.elementId,
            name: 'card_cvv',
            placeholder: options.placeholder || ''
        };
        return this;
    }
    build() {
        if (!this.cvv) {
            throw new field_null_exeption_1.FieldNullException('CVV');
        }
        if (!this.cardNumber) {
            throw new field_null_exeption_1.FieldNullException('card number');
        }
        this.cvvState = {
            error: error_types_contants_1.ErrorTypes.EMPTY,
            value: '',
            isValid: false,
            isFocused: false
        };
        this.dom
            .loadSpreedlyScript()
            .then(() => {
            this.initSpreedly();
            this.eventBus.dipatchEvent(event_types_constants_1.EventTypes.RECACHE_READY);
        })
            .catch(error => this.eventBus.dipatchEvent(event_types_constants_1.EventTypes.RECACHE_LOAD_READY, error));
    }
    initSpreedly() {
        if (is_spreedly_1.isSpreedy()) {
            this.cvvState = {
                error: error_types_contants_1.ErrorTypes.EMPTY,
                isFocused: false,
                isValid: false,
                value: ''
            };
            Spreedly.init(this.isProduction ? spreedly_config_1.SpreedlyConfig.PROD : spreedly_config_1.SpreedlyConfig.DEV, {
                numberEl: this.cardNumber.elementId,
                cvvEl: this.cvv.elementId
            });
        }
        this.startSpreedlyEvents();
    }
    startSpreedlyEvents() {
        Spreedly.on('ready', () => {
            Spreedly.setRecache(this.token);
            Spreedly.setFieldType('number', 'text');
            Spreedly.setStyle('number', 'display: none');
            Spreedly.transferFocus('cvv');
            Spreedly.setPlaceholder('cvv', this.cvv.placeholder);
            Spreedly.setStyle('cvv', 'width: 100%; height: 100%; padding: 0px;');
        });
        Spreedly.on('fieldEvent', (name, type, activeEl, inputProperties) => {
            switch (name) {
                case 'cvv':
                    if (type === 'input') {
                        this.cvvState.isValid = inputProperties.validCvv;
                        this.cvvState.error = inputProperties.validCvv ? error_types_contants_1.ErrorTypes.EMPTY : error_types_contants_1.ErrorTypes.INVALID_CVV;
                        this.notifyChangeState();
                    }
                    else if (type === 'focus') {
                        this.cvvState.isFocused = true;
                        this.notifyChangeState();
                    }
                    else if (type === 'blur') {
                        this.cvvState.isFocused = false;
                        this.notifyChangeState();
                    }
                    break;
            }
        });
    }
    addEventListener(eventName, cb) {
        this.eventBus.addEventListener(eventName, cb);
    }
    notifyChangeState() {
        this.eventBus.dipatchEvent(event_types_constants_1.EventTypes.CVV_CHANGE, this.cvvState);
    }
    recache() {
        return new Promise((resolve, reject) => {
            if (!this.cvvState.isValid) {
                return reject({ message: 'You need fill all fields' });
            }
            Spreedly.recache();
            Spreedly.on('errors', (errors) => reject(errors));
            Spreedly.on('recache', (token, paymentMethod) => resolve({ token, paymentMethod }));
        });
    }
    removeHandlers() {
        if (is_spreedly_1.isSpreedy()) {
            Spreedly.removeHandlers();
            this.eventBus.removeEventListener();
        }
    }
}
exports.RecacheManager = RecacheManager;
